import React from 'react'
import {
  MDBCol,
  MDBRow
} from "mdb-react-ui-kit";
// import Certified from '../Image/Certified.webp'
import Certified from '../Image/Certified.svg'
function Certified_comp() {
  const imageUrls = [
    {
      url: Certified,
      alt: 'Certified Company'
    }
  ]

  return (
    <div className="my-4">

      {/* ------------------------Monile view------------------------ */}
      <div className="pt-3 d-sm-block d-md-none">
        <div className="container">
          <MDBRow className="d-flex justify-content-center">
          <MDBCol md="10" className="px-5 text-center pt-2 mobile_collabration_img">
              <h2 className="display-6">We are Proudly Certified by</h2>
              <p className="mt-3">We're thrilled to announce that InternsElite has been certified for its outstanding educational offerings, assuring professionals and students of our commitment to excellence.</p>
          </MDBCol>
          </MDBRow>
        </div>
        <div className="container">
            <div className="row d-flex justify-content-center">
              {imageUrls.map((image, index) => (
                <div className='col-12 text-center'>
                  <img
                    className='certifide_comp_mobile_icon_image' 
                    src={image.url} alt={image.alt}
                    title={image.title}
                    onContextMenu={(e) => e.preventDefault()}
                  />
                </div>
              ))}
            </div>
          </div>
      </div>


      {/* ------------------------Dasktop view------------------------ */}
    
      <div className="pt-3 d-md-block d-none">
        <div className="container">
          <MDBRow className="d-flex justify-content-center">
          <MDBCol md="10" className="px-5 text-center pt-2 collabration_img">
              <h2 className="display-6">We are Proudly Certified by</h2>
              <p className="mt-3 px-5">We're thrilled to announce that InternsElite has been certified for its outstanding educational offerings, assuring professionals and students of our commitment to excellence.</p>
          </MDBCol>
          </MDBRow>
        </div>
        <div className="container mt-2">
              {imageUrls.map((image, index) => (
                <div className='text-center'>
                  <img
                    className='certifide_comp_icon_image' 
                    src={image.url} alt={image.alt}
                    title={image.title}
                    onContextMenu={(e) => e.preventDefault()}
                  />
                </div>
              ))}
          </div>
      </div>
    </div>
  )
}

export default Certified_comp
